// src/components/analytics/LoyaltyGrowthChart.js
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const LoyaltyGrowthChart = ({ dateRange, selectedProgram, granularity }) => {
    // Mock data based on granularity (e.g., last 6 months for monthly)
    const generateData = () => {
        const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']; // Example for 6 months
        const dataPoints = [1000, 1050, 1100, 1180, 1250, 1300]; // Example member count

        return {
            labels: labels,
            datasets: [
                {
                    label: 'Total Loyalty Members',
                    data: dataPoints,
                    borderColor: 'rgb(99, 102, 241)', // Indigo-600
                    backgroundColor: 'rgba(99, 102, 241, 0.2)',
                    fill: true,
                    tension: 0.3,
                },
            ],
        };
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: { family: 'Inter, sans-serif' },
                    color: '#374151',
                },
            },
            title: {
                display: false,
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                bodyFont: { family: 'Inter, sans-serif' },
                titleFont: { family: 'Inter, sans-serif', weight: 'bold' }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: '#4b5563',
                    font: { family: 'Inter, sans-serif' }
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(209, 213, 219, 0.4)',
                },
                ticks: {
                    color: '#4b5563',
                    font: { family: 'Inter, sans-serif' },
                    callback: function(value) {
                        return value.toLocaleString();
                    }
                },
            },
        },
    };

    return (
        <div className="bg-white rounded-lg shadow-md p-6 h-96 flex flex-col">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Loyalty Program Growth</h3>
            <p className="text-sm text-gray-500 mb-4">New members joining your programs over time.</p>
            <div className="flex-1 relative">
                <Line data={generateData()} options={options} />
            </div>
        </div>
    );
};

export default LoyaltyGrowthChart;